import { required, unique, shape, items, concatFailure } from '@totalsoft/pure-validations';

export const automaticStateTransitionValidator = shape({
  documentTypeId: required,
  fromStateId: required
});

export const automaticStateTransitionRuleValidator = concatFailure(
  unique(x => x.toStateId || {}, 'AutomaticStateTransitionRules.Validators.ToStateIdUnique'),
  unique(x => x.orderNo || {}, 'AutomaticStateTransitionRules.Validators.OrderNoUnique'),
  items(
    shape({
      toStateId: required,
      formula: required,
      orderNo: required
    })
  )
);
